import ArticlesList from '@/components/articles/ArticlesList'
import ArticlesNew from '@/components/articles/ArticlesNew'
import ArticlesShow from '@/components/articles/ArticlesShow'
import ArticlesEdit from '@/components/articles/ArticlesEdit'
export default [
  {
    path: '/articles',
    name: 'articles',
    component: ArticlesList,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/articles/new',
    name: 'articlesNew',
    component: ArticlesNew,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/articles/:id/show',
    name: 'articlesShow',
    component: ArticlesShow,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/articles/:id/edit',
    name: 'articlesEdit',
    component: ArticlesEdit,
    meta: {
      requiresAuth: true
    }
  }
]



// WEBPACK FOOTER //
// ./src/router/articlesRoutes.js